import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useDeleteSharingSchedule } from "../../../apis";
import { DeleteSharingScheduleModalProps } from "./DeleteSharingScheduleModal.types";

import styles from "./DeleteSharingScheduleModal.module.scss";

const DeleteSharingScheduleModal = ({
  isOpen,
  id,
  onClose,
  onDeleteSuccess
}: DeleteSharingScheduleModalProps) => {
  const { t } = useTranslation();

  const deleteSharingSchedule = useDeleteSharingSchedule({
    onSuccess: () => {
      onClose();
      onDeleteSuccess();
      toast.success("Sharing schedule deleted successfully");
    }
  });

  const onDeleteInventoryManager = () => {
    deleteSharingSchedule.mutate(id);
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t("Delete Sharing Schedule")}
      isLoading={deleteSharingSchedule.isLoading}
      okText={t("Delete")}
      onOk={onDeleteInventoryManager}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.deleteManagerModal_text}>
        {t("Are you sure you want to delete this sharing schedule?")}
      </p>
    </Modal>
  );
};

export default DeleteSharingScheduleModal;
